export default "__VITE_ASSET__DvIGIbBh__"